<template>
  <div id="carData">
   
      

        <b-row>


          <b-col md="6">
            <h4>Zahlungsperiode</h4>
            <base-input rules="required" name="Zahlungsperiode">
              <el-select
                v-model="offer.paymentterm"
                filterable
                placeholder="Zahlungsperiode"
              >
                <el-option
                  v-for="option in offer.paymentterms"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                >
                </el-option>
              </el-select>
            </base-input>
          </b-col>


          <b-col md="12" v-if="false">
            <h4>
                Zahlungsperiode
            </h4>

            <b-form-radio-group v-model="offer.paymentterm">
       
                 <div v-for="option in offer.paymentterms" :key="option.value">
                   <b-form-radio v-bind="option.value" :value="option.value" name="checked" class="mb-3" :checked="option.label == offer.paymentterm">
                  {{ option.label }}
                  </b-form-radio>
              </div>

            </b-form-radio-group>
          </b-col>
        </b-row>


        <b-row v-if="show_only_driver">
          <b-col md="6">
            <h4>
                Kunde ist der einzige Fahrer ?
            </h4>

            <b-form-radio-group v-model="offer.holder_only_driver">
              <div>
                <b-form-radio value="1" name="checked" class="mb-3">
                  Ja
                </b-form-radio>
                  <b-form-radio value="0" name="unchecked" class="mb-3">
                  Nein
                </b-form-radio>
              </div>
            </b-form-radio-group>
          </b-col>
        </b-row>




<template v-if="this.offer.selected_only_driver || offer.is_company">

        <!-- b-row>
          <b-col md="6">
            <b-form-checkbox class="mb-3" v-model="offer.holder_only_driver">
              VN ist einiziger Fahrer
            </b-form-checkbox>
          </b-col>
        </b-row -->

        <b-row>
          <b-col md="6" v-if="display_joungest_driver">
            <h4>Jüngster Fahrer</h4>
            <base-input
              prepend-icon="fas fa-calendar"
              v-model="offer.youngest_driver_dob"
              name="Jüngster Fahrer"
              rules="required"
              type="date"
              placeholder="DD.MM.YYYY"
            >
            </base-input>
          </b-col>

          <b-col md="6" v-if="display_oldest_driver">
            <h4>Ältester Fahrer</h4>
            <base-input
              prepend-icon="fas fa-calendar"
              v-model="offer.oldest_driver_dob"
              name="Ältester Fahrer"
              rules="required"
              type="date"
              placeholder="DD.MM.YYYY"
            >
            
            </base-input>
          </b-col>
        </b-row>

</template>
<template>


        <b-row>
          <b-col md="6">
            <h4>
                Kunde hat einen freien SFR ?
            </h4>

            <b-form-radio-group v-model="offer.customer_has_free_sfr">
              <div>
                <b-form-radio value="1" name="checked" class="mb-3">
                  Ja
                </b-form-radio>
                  <b-form-radio value="0" name="unchecked" class="mb-3">
                  Nein
                </b-form-radio>
              </div>
            </b-form-radio-group>
          </b-col>
        </b-row>

        <!-- b-row>
          <b-col md="6">
            <b-form-checkbox class="mb-3" v-model="offer.customer_has_free_sfr">
              Kunde hat einen freien SFR
            </b-form-checkbox>
          </b-col>
        </b-row -->
<template>

        <b-row v-if="display_second_vehicle">
          <b-col md="12">
            <h4>
                Ist auf den Kunden, den Ehe- oder Lebenspartner oder ein
              Elternteil bereits ein PKW,ein (Leicht-)Kraftrad, ein Camping-Kfz
              oder einen Lkw bis 3,5 t zulässige Gesamtmasse im
              Privat-/Werkverkehr zugelassen?
            </h4>

            <b-form-radio-group v-model="offer.has_second_vehicle" v-if="offer.is_company">
              <div>
                <b-form-radio value="1" name="checked" class="mb-3">
                  Ja (Sondereinstufung)
                </b-form-radio>
                  <b-form-radio value="0" name="unchecked" class="mb-3">
                  Nein
                </b-form-radio>
              </div>
            </b-form-radio-group>

            <b-form-radio-group v-model="offer.has_second_vehicle" v-if="!offer.is_company">
              <div>
                <b-form-radio value="1" name="checked" class="mb-3">
                  Ja (Sondereinstufung)
                </b-form-radio>
                  <b-form-radio value="0" name="unchecked" class="mb-3">
                  Nein (Führerscheinregelung)
                </b-form-radio>
              </div>
            </b-form-radio-group>
          </b-col>
        </b-row>


        <!-- b-row v-if="display_second_vehicle">
          <b-col md="12">
            <b-form-checkbox class="mb-3" v-model="offer.has_second_vehicle">
              Ist auf den Kunden, den Ehe- oder Lebenspartner oder ein
              Elternteil bereits ein PKW,ein (Leicht-)Kraftrad, ein Camping-Kfz
              oder einen Lkw bis 3,5 t zulässige Gesamtmasse im
              Privat-/Werkverkehr zugelassen?
            </b-form-checkbox>
            <br />
          </b-col>
        </b-row -->

        <b-row v-if="offer.customer_has_free_sfr == 1">
          <b-col md="6">
            <h4>SF Haftpflicht</h4>

            <base-input rules="required" name="SF Haftpflicht">
              <el-select  :disabled="sf_enabled"
                v-model="offer.customer_sf"
                filterable
                placeholder="SF Haftpflicht"
              >
                <el-option
                  v-for="option in offer.sf_classes"
                  :key="option.value"
                  :label="option.value"
                  :value="option.value"
                >
                </el-option>
              </el-select>
            </base-input>

          </b-col>

          <b-col md="6">
            <h4>SF Kasko</h4>
            <base-input rules="required" name="SF Kasko">
              <el-select :disabled="sf_enabled"
                v-model="offer.customer_sf2"
                filterable
                placeholder="SF Kasko"
              >
                <el-option
                  v-for="option in offer.sf_classes"
                  :key="option.value"
                  :label="option.value"
                  :value="option.value"
                >
                </el-option>
              </el-select>
            </base-input>
          </b-col>
        </b-row>


        <!-- b-row v-if="!display_sf">
          <b-col md="6">
            <h4>SF Haftpflicht</h4>

            <p>{{ offer.customer_sf }}</p>

          </b-col>

          <b-col md="6">
            <h4>SF Kasko</h4>
            <p>{{ offer.customer_sf2 }}</p>
          </b-col>
        </b-row -->



        <!-- WENN FÜHRERSCHEINREGEL -->
        <template v-if="license_age"></template>
        <b-row v-if="display_license_date">
          <b-col md="6">
            <h4>Ausstellungsdatum Führerschein</h4>
            <base-input
              prepend-icon="fas fa-calendar"
              v-model="offer.license_date"
              name="Ausstellungsdatum Führerschein"
              rules="required"
              type="date"
              placeholder="DD.MM.YYYY"
            >
            
            </base-input>
          </b-col>
        </b-row>

        <!-- WENN EINSTUFUNGSGRUND -->
        <b-row v-if="display_holder_sf_selection">
          <b-col md="6">
            <h4>Auf wen ist das Fahrzeug zugelassen?</h4>
        <base-input rules="required" name="Auf wen ist das Fahrzeug zugelassen?">
                          <el-select v-model="offer.second_vehicle_holder"
                placeholder="Auf wen ist das Fahrzeug zugelassen?"
              >
                <template v-if="offer.is_company != 1">
                  <el-option
                    v-for="option in offer.possible_sf_holders_privat"
                    :key="option.label"
                    :label="option.label"
                    :value="option.label"
                  >
                  </el-option>
                </template>

                <template v-if="offer.is_company == 1">
                  <el-option
                    v-for="option in offer.possible_sf_holders_company"
                    :key="option.label"
                    :label="option.label"
                    :value="option.label"
                  >
                  </el-option>
                </template>

              </el-select>

            </base-input>
          </b-col>
        </b-row>

        <b-row v-if="display_holder_sf_selection">
          <b-col md="6">
            <h4>SF-Einstufung des Fahrzeuges (Haftpflichtversicherung)</h4>
            <base-input
              prepend-icon="fas fa-car"
              placeholder="SF-Klasse"
              v-model="offer.sf_holder_sf"
              name="SF-Klasse"
              rules="required"
            ></base-input>
          </b-col>



          <b-col md="6">
            <h4>Versicherung des Fahrzeuges (Referenz) </h4>
            <base-input rules="required" name="Versicherung des Fahrzeuges (Referenz)">
              <el-select
                v-model="offer.insurance_id"
                filterable
                remote
                reserve-keyword
                placeholder="Versicherung des Fahrzeuges (Referenz)"
                :remote-method="searchInsurances"
                :loading="loading"
              >
                <el-option
                  v-for="item in insurances"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </base-input>
          </b-col>


          <!-- b-col md="6">
            <h4>Referenzversicherung</h4>
            <base-input
              prepend-icon="fas fa-university"
              placeholder="Referenzversicherung"
              v-model="offer.sf_holder_insurance"
              name="Referenzversicherung"
              rules="required"
            ></base-input>
          </b-col -->
        </b-row>
        </template>
        </template>
        
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex";
import moment from "moment";
import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import dateUtil from "../../../services/date";
import offerUtil from "../../../services/offer";



    
export default {
  name: "insurance",
  props: {
    title: "",
    icon: "",
  },
  components: {
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      loading: false,
      today: new Date(),

      options: [],
      insurances: [],
      
      selected_only_driver: false,
      selected_free_sfr: false,
      selected_second_vehicle: false,

      has_free_sfr: true,
      has_second_vehicle: false,
    }
  },
  methods: {
    fetchParticipations() {
      this.loading = true;
      let qtp = "car";
      if(this.offer.is_van){
        qtp = 'van';
      }
      this.$api
        .getParticipations(qtp)
        .then((response) => {
          this.offer.participations = response.data.items.map((item) => {
            let str = "";

            if (item.vk > 0) {
              str += "Vollkasko SB " + item.vk + " ";
            }
            
            //if (true) {
            str += "Teilkasko SB " + item.tk + " ";
            //} 

            if (item.name == "Nur Haftpflicht") {
              str = item.name;
            }

            return { value: item.id, label: str };
          });
        })
        .catch((e) => {
          //console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    fetchPaymentterms() {
      this.loading = true;
      this.$api
        .getPaymentterms()
        .then((response) => {
        //  //console.log(response);
          this.offer.paymentterms = response.data.items.map((item) => {
            return { value: item.id, label: item.name };
          });
        })
        .catch((e) => {
          //console.log(e);
        })
        .finally(() => {
          //console.log(this.offer.paymentterms);
          //console.log(this.offer.paymentterm);
          this.offer.paymentterm = this.offer.paymentterms[0].value;
          this.loading = false;
          //console.log(this.offer.paymentterm);
        });
    },

    fetchInsurances() {
      this.loading = true;
      this.$api
        .getInsurances()
        .then((response) => {
        //  //console.log(response);
          this.insurances = response.data.items.map((item) => {
            return { value: item.id, label: item.vu_name };
          });
        })
        .catch((e) => {
          //console.log(e);
        })
        .finally(() => {
         // this.offer.insurance_id = this.offer.insurances[0].id;
          this.loading = false;
        });
    },

    searchInsurances(query) {
      if (query !== "") {
        this.loading = true;
        this.$api
          .getInsurances(query)
          .then((response) => {
            //console.log(response)
            this.insurances = [];
            this.insurances = response.data.items.map((item) => {
              return { value: item.id, label: item.vu_name };
            });
          })
          .catch((e) => {
            //console.log(e);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
/*
    getInsuranceNameSelection(klid) {
      
      this.offer.insurance_id = this.insurances.find(
        (itm) => itm.value === klid
      ).plz;

      this.offer.holder_kravag_location_id = klid;

    },
*/
    fetchSfClasses() {
      this.loading = true;
      /*
      this.$api
        .getPaymentterms()
        .then((response) => {
          this.offer.sf_classes = response.data.items.map((item) => {
            return { value: item.id, label: item.name };
          });
        })
        .catch((e) => {
          //console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
        */
    },

    setHiddenSf(l_age) {
    //  this.offer.needs_sf_classes = true;
      if (l_age > 0) {
 //       //console.log("setting sf to 0.5");
        this.offer.customer_sf = "SF 1/2";
        this.offer.customer_sf2 = "SF 1/2";
      } else {
   //     //console.log("setting sf to 0");
        this.offer.customer_sf = 0;
        this.offer.customer_sf2 = 0;
      }
    //    this.offer.needs_sf_classes = true;
    //    this.offer.sf_classes_enabled = false;
    },

    setDefaultDates() {
   /*
   //console.log("####### S -> offer.all_ages_oder_23()");
      //console.log(offerUtil.all_ages_over_23(this.offer));
      //console.log("####### E -> offer.all_ages_oder_23()");
*/

      this.$store.state.offer.dob = dateUtil.dateToday();
      this.$store.state.offer.youngest_driver_dob = this.$store.state.offer.dob;
      this.$store.state.offer.oldest_driver_dob = this.$store.state.offer.dob;

/*
      this.$store.state.offer.dob = dateUtil.dateToday();
      this.$store.state.offer.youngest_driver_dob = dateUtil.dateToday();
      this.$store.state.offer.oldest_driver_dob = dateUtil.dateToday();
*/


      this.$store.state.offer.insurance_start = dateUtil.dateToday();
 //     //console.log("setting date for insurance_start:");
 //     //console.log(dateUtil.dateToday());
      this.$store.state.offer.car_first_registration = dateUtil.dateToday();
 //     //console.log("setting date for car_first_registration:");
 //     //console.log(dateUtil.dateToday());
      this.$store.state.offer.license_date = dateUtil.dateToday();
  //    //console.log("setting date for license_date:");
  //    //console.log(dateUtil.dateToday());
    },


    getPaymenttermSelection(klid){
      ////console.log("get zip from slection");
      //this.zipcode = this.options.find( zip => zip.value === klid);
      this.offer.customer_zip = this.options.find( zip => zip.value === klid).plz;
      this.offer.customer_city = this.options.find( zip => zip.value === klid).label;
      ////console.log(this.zipcode);
     // const result = inventory.find( fruit => fruit.name === 'cherries' );
    },

    sfInfoText() {
      // lookup text and display it
    },

    apply_sf_filter(){
      
    },

    ol_apply_rules() {
      if (this.offer.is_company) {
        //console.log("customer is company");
        holders_list = ["N", "C", "L", "G", "I", "W", "S"];
        leveling_list = ["0", "1", "2", "3", "4", "5", "6", "7"];
        leveling_type_list = [
          "",
          "Z",
          "E",
          "L",
          "N",
          "D",
          "O",
          "H",
          "B",
          "C",
          "I",
          "F",
          "V1",
          "V2",
        ];
      } else {
      }
    },
  },
  computed: {
    ...mapGetters(
      "currentAccount",
     ),
    ...mapState({
      offer: (state) => state.offer,
      second_vehicle: (state) => state.offer.has_second_vehicle,
      only_driver: (state) => state.offer.holder_only_driver,
      dob: (state) => state.offer.dob,
      oldest_driver_dob: (state) => state.offer.oldest_driver_dob,
      youngest_driver_dob: (state) => state.offer.youngest_driver_dob,
      has_holder: (state) => state.offer.has_holder,
      holder_id: (state) => state.offer.holder_id,
      car_first_registration: (state) => state.offer.car_first_registration,
      mileage: (state) => state.offer.mileage,
      insurance_start: (state) => state.offer.insurance_start,
    //  participation: (state) => state.offer.participation,
      paymentterm: (state) => state.offer.paymentterm,
      customer_sf: (state) => state.offer.customer_sf,
      customer_sf2: (state) => state.offer.customer_sf2,
      license_date: (state) => state.offer.license_date,
      customer_has_free_sfr: (state) => state.offer.customer_has_free_sfr,
      sf_holder_sf: (state) => state.offer.sf_holder_sf,
      sf_holder_insurance: (state) => state.offer.sf_holder_insurance,
      second_vehicle_holder: (state) => state.offer.second_vehicle_holder,
      

    }),


    license_age() {
     // return true;
      if (this.offer.license_date) {
        let currentDate = new Date();
        let birthDate = new Date(this.offer.license_date);
        let difference = currentDate - birthDate;
        let age = Math.floor(difference / 31557600000);
     //   //console.log(age);
  //      this.setHiddenSf(age);
        return age;
      }
      return "";
    },

    
    //offer.has_second_vehicle

    sf_enabled() {      
    //  //console.log("####### S -> offer.age_over_23()");
    //  //console.log(offerUtil.apply_rules(this.offer));
    //  //console.log("####### E -> offer.age_over_23()");   


    //console.log("####### E -> offer.age_over_23()");   
    //console.log("####### E -> offer.age_over_23()");   
    //console.log("####### E -> offer.age_over_23()");   
    //console.log("####### E -> offer.age_over_23()");   
    //console.log(this.offer.customer_has_free_sfr);   
    //console.log("####### E -> offer.age_over_23()");   
    //console.log("####### E -> offer.age_over_23()");   
    //console.log("####### E -> offer.age_over_23()");   
      
      if(this.offer.customer_has_free_sfr){
        return false;
      }
      return !this.offer.sf_classes_enabled;


    },

    display_sf() {
      if (this.offer.customer_has_free_sfr != false || this.offer.customer_has_free_sfr != 0) {
        return true;
      }
/*
      if (this.offer.needs_sf_classes) {
        return true;
      }

      if(this.offer.has_second_vehicle) {
        return false;
      }
      */
      return false;
    },

    show_only_driver(){
      if(this.offer.is_car == 1){
        if(this.offer.is_company == 1){
          return false;
        }
        return true;
      }

      if(this.offer.is_van == 1){
        return false;
      }

/*

      if(!this.offer.is_company){
        return false;
      } 
      if(this.offer.is_van == 1){
        return false;
      }
*/
      return true;
    },

    display_holder_sf() {
      //return true;
      if (this.offer.customer_has_free_sfr == true || this.offer.customer_has_free_sfr == 1) {
        return false;
      }
      if (this.offer.has_second_vehicle) {
        return true;  
      }
    },

    display_holder_sf_selection() {
 //     //console.log("display_holder_sf_selection()");
 //     //console.log(this.offer.customer_has_free_sfr);
 //     //console.log("has_second_vehicle()");
 //     //console.log(this.offer.has_second_vehicle);
      if (this.offer.customer_has_free_sfr != false || this.offer.customer_has_free_sfr != 0) {
        return false;
      }
 //     //console.log("has_second_vehicle()");
 //     //console.log(this.offer.has_second_vehicle);

        if (this.offer.has_second_vehicle == 1 || this.offer.has_second_vehicle == true) {
          return true;
        }
        else{
          return false;
        }
    },

    display_holder_insurance() {
      return false;
    },

    display_license_date() {
      //return true;
      if(this.offer.is_company == 1){
        return false;
      }
      
      if (this.offer.customer_has_free_sfr == false || this.offer.customer_has_free_sfr == 0) {
        if(this.offer.has_second_vehicle == 0){
          return true;
        }
      }
      else{
        return false;
      }

    },

    display_joungest_driver() {
      if(this.offer.is_van == 1){
        if (this.offer.customer_has_free_sfr == 0) {
          if (this.offer.has_second_vehicle == 1) {
            return true;
          }
          return false;
        }
        return false;
      }
      if (this.offer.holder_only_driver == 0) {
        return true;
      }
      if (this.offer.is_company) {
        return true;
      }
    },

    display_oldest_driver() {
      if(this.offer.is_van == 1){
        if (this.offer.customer_has_free_sfr == 0) {
          if (this.offer.has_second_vehicle == 1) {
            return true;
          }
          return false;
        }
        return false;
      }
      if (this.offer.holder_only_driver == 0) {
        return true;
      }
      if (this.offer.is_company) {
        return true;
      }
    },

    display_second_vehicle() {
      if (this.offer.customer_has_free_sfr == false || this.offer.customer_has_free_sfr == 0) {
        return true;
      }
    },
  },
  watch: {

    second_vehicle(newValue, oldValue) {
      console.log(
        `Updating has_second_vehicle from ${oldValue} to ${newValue}`
      );
      if (newValue == 1) {
        this.offer.needs_license_date = false;
        this.offer.needs_sf_classes = false; //true;
      } else {
        this.offer.needs_license_date = true;
        this.offer.needs_sf_classes = false;
      }
            //console.log('queryParameter changed -> running apply_rules:');
      console.log(offerUtil.apply_rules(this.offer));
    },
    only_driver(newValue, oldValue) {
     // //console.log(this.offer.youngest_driver_dob);
      console.log(
        `Updating only_driver from ${oldValue} to ${newValue}`
      );

      this.offer.selected_only_driver = true;


      if(this.offer.is_company != 1){
        if (newValue == "1"){
        this.offer.youngest_driver_dob = this.offer.dob
        this.offer.oldest_driver_dob = this.offer.dob
      }
      else {
//        this.offer.youngest_driver_dob = ''; //Date.now(); //''
//        this.offer.oldest_driver_dob = ''; //Date.now(); //''
      }
      }

     //       //console.log('queryParameter changed -> running apply_rules:');
    //  //console.log(offerUtil.apply_rules(this.offer));
    },

second_vehicle_holder(newValue, oldValue) {
      //console.log('queryParameter changed -> running apply_rules:');
      console.log(offerUtil.apply_rules(this.offer));
    },

sf_holder_sf(newValue, oldValue) {
      //console.log('queryParameter changed -> running apply_rules:');
      console.log(offerUtil.apply_rules(this.offer));
    },
dob(newValue, oldValue) {
      //console.log('queryParameter changed -> running apply_rules:');
      //console.log(offerUtil.apply_rules(this.offer));
    },

youngest_driver_dob(newValue, oldValue) {
      //console.log('queryParameter changed -> running apply_rules:');
     console.log(offerUtil.apply_rules(this.offer));
    },

oldest_driver_dob(newValue, oldValue) {
      //console.log('queryParameter changed -> running apply_rules:');
      console.log(offerUtil.apply_rules(this.offer));
    },
has_holder(newValue, oldValue) {
      //console.log('queryParameter changed -> running apply_rules:');
      //console.log(offerUtil.apply_rules(this.offer));
    },
holder_id(newValue, oldValue) {
      console.log('queryParameter holder_id changed -> running apply_rules:');
      console.log(offerUtil.apply_rules(this.offer));
    },
car_first_registration(newValue, oldValue) {
      //console.log('queryParameter changed -> running apply_rules:');
      console.log(offerUtil.apply_rules(this.offer));
    },
mileage(newValue, oldValue) {
      //console.log('queryParameter changed -> running apply_rules:');
      console.log(offerUtil.apply_rules(this.offer));
    },
insurance_start(newValue, oldValue) {
      //console.log('queryParameter changed -> running apply_rules:');
      console.log(offerUtil.apply_rules(this.offer));
    },
holder_only_driver(newValue, oldValue) {
      this.offer.selected_only_driver = true;
    },
    /*
participation(newValue, oldValue) {
      //console.log('queryParameter changed -> running apply_rules:');
      //console.log(offerUtil.apply_rules(this.offer));
    },

*/
sf_holder_insurance(newValue, oldValue) {
      //console.log('queryParameter changed -> running apply_rules:');
      //console.log(offerUtil.apply_rules(this.offer));
    },
paymentterm(newValue, oldValue) {
      //console.log('paymentterm queryParameter changed -> running apply_rules:');
      //console.log(`Updating from ${oldValue} to ${newValue}`);
      //console.log(offerUtil.apply_rules(this.offer));
    },
customer_sf(newValue, oldValue) {
      //console.log('queryParameter changed -> running apply_rules:');
      //console.log(offerUtil.apply_rules(this.offer));
    },

customer_sf2(newValue, oldValue) {
      //console.log('queryParameter changed -> running apply_rules:');
      //console.log(offerUtil.apply_rules(this.offer));
    },

license_date(newValue, oldValue) {
      console.log('queryParameter license_date changed -> running apply_rules:');
      console.log(offerUtil.apply_rules(this.offer));
    },

customer_has_free_sfr(newValue, oldValue) {
  this.offer.pricing = [];
      console.log('queryParameter customer_has_free_sfr changed -> running apply_rules:');
      console.log('queryParameter customer_has_free_sfr changed ->' +this.offer.customer_has_free_sfr);
      console.log(offerUtil.apply_rules(this.offer));
        var sf = this.offer.customer_sf 
      var sf2 = this.offer.customer_sf2
this.offer.selected_free_sfr = true;
if(newValue == 1){
  this.offer.has_second_vehicle = false;
      //this.offer.selected_free_sfr = true;

      this.offer.customer_sf = sf;
      this.offer.customer_sf2 = sf2;
//      this.offer.customer_sf = '';
//    this.offer.customer_sf2 = '';
}
else{
        this.offer.customer_sf = '';
      this.offer.customer_sf2 = '';
  //    this.offer.customer_sf = sf;
  //    this.offer.customer_sf2 = sf2;
}
    },
/*
      '$store.state.offer': {
    deep: true,
    handler(newVal) {
      //console.log(newVal);
      //console.log('queryParameter changed -> running apply_rules:');
      ////console.log(offerUtil.apply_rules(this.offer));
    }
  },
*/


  },
  mounted() {
    
    this.fetchParticipations();
    this.fetchPaymentterms();
    //this.setDefaultDates();
    this.fetchInsurances();

    if(this.offer.is_company == 1){
      this.offer.second_vehicle_holder = this.offer.possible_sf_holders_company[0].label;
    }
  },
};
</script>
<style>
</style>